module.exports = __webpack_public_path__ + "img/Prancheta_1.9d110883.png";